import { motion } from 'framer-motion'
import SocialLinks from '@/components/ui/SocialLinks'
import { bio } from '@/data/projects'
import { useIsSSR } from '@/context/SSRContext'

const stagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15 },
  },
}

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] as const },
  },
}

// "i" rendered as dotless ı + a separate flying dot
// Uses CSS @keyframes instead of Framer Motion to avoid SSR hydration conflicts
function AnimatedI() {
  return (
    <span className="relative inline-block">
      <span className="inline-block animate-i-bounce">ı</span>
      <span
        className="absolute rounded-full bg-current pointer-events-none animate-i-dot-bounce"
        style={{ width: '0.13em', height: '0.13em', left: '50%', top: '0.18em', marginLeft: '-0.065em' }}
      />
    </span>
  )
}

function AnimatedWord() {
  return (
    <span className="inline-flex items-baseline">
      {'Motion'.split('').map((char, i) =>
        char === 'i' ? (
          <AnimatedI key={i} />
        ) : (
          <span key={i}>{char}</span>
        )
      )}
    </span>
  )
}

export default function HeroSection() {
  const isSSR = useIsSSR()
  const rest = bio.headline.replace(/Motion\s/, '')

  return (
    <section className="flex flex-col justify-center max-w-container mx-auto px-6 sm:px-8 pt-6 md:pt-10">
      <motion.div
        variants={stagger}
        initial={isSSR ? 'visible' : 'hidden'}
        animate="visible"
        className="flex flex-col gap-6"
      >
        <motion.h1 variants={fadeUp} className="text-h1 text-text-secondary max-w-text">
          <AnimatedWord /> {rest}
        </motion.h1>
        {bio.availableForWork && (
          <motion.a
            variants={fadeUp}
            href="https://www.linkedin.com/in/nataliatarasova-motion/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
          >
            <span className="w-2 h-2 rounded-full bg-accent animate-pulse" />
            <span className="text-label uppercase tracking-widest text-text-muted">
              Available for work
            </span>
          </motion.a>
        )}
        <motion.div variants={fadeUp}>
          <SocialLinks />
        </motion.div>
      </motion.div>
    </section>
  )
}
